import styled, { keyframes, css } from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { themeMode, palette, variant } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
var SkeletonGradientAnimation = keyframes(["0%{background-position:0% 50%}50%{background-position:100% 50%}100%{background-position:0% 50%}"]);
var skeletonVariant = variant({
  prop: "variant",
  variants: {
    rectangle: {
      borderRadius: "base"
    },
    round: {
      aspectRatio: "1/1",
      borderRadius: "round"
    }
  }
});
var Skeleton = styled(Box).withConfig({
  componentId: "sc-1sntess-0"
})(["position:relative;display:flex;overflow:hidden;background-color:transparent;&::before{content:'';height:100%;position:absolute;width:100%;top:0;left:0%;background-size:400% 400%;", ";animation:", " 5s ease infinite;}", ";"], themeMode({
  light: css(["background-image:linear-gradient( -45deg,", " 0%,", " 48%,", " 52%,", " 100% );"], palette("neutral.200"), palette("platinum.100"), palette("platinum.100"), palette("neutral.200")),
  dark: css(["background-image:linear-gradient( -45deg,", " 0%,", " 48%,", " 52%,", " 100% );"], palette("platinum.800"), palette("platinum.700"), palette("platinum.700"), palette("platinum.800"))
}), SkeletonGradientAnimation, skeletonVariant);
export { Skeleton, SkeletonGradientAnimation };